import { $$, on, removeAttr, setAttr } from "../../utils/dom";
import { customJsMedia } from "../../variables/mediaQueries.json";

// Our navigationLists should always be expanded in any viewport larger
// than --tablet, so as soon as the viewport switches between mobile / tablet
// we expand / contract them.

const mediaQuery = matchMedia(customJsMedia["--tablet"]);

// TODO: refactor this to use the toggleDetailsOpen-function in the utils file instead
const toggleDetailsOpen = (isTablet: boolean) => {
  const navigationLists = $$(".js-navigationList");
  if (navigationLists) {
    navigationLists.forEach((navigationList: HTMLElement) => {
      const details = $$("details", navigationList);
      if (details) {
        details.forEach((item: HTMLElement) => {
          if (isTablet) {
            setAttr(item, "open");
          } else {
            removeAttr(item, "open");
          }
        });
      }
    });
  }
};

const onMatchMedia = (event: MediaQueryListEvent) =>
  toggleDetailsOpen(event.matches);

export const onContentLoaded = () => {
  toggleDetailsOpen(mediaQuery.matches);
  mediaQuery.addListener(onMatchMedia);
};

if (process.env.NODE_ENV !== "development") {
  on(document, "DOMContentLoaded", onContentLoaded);
}
